import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

/**
 * Component to automatically track page views.
 * Add this component to your main App component or router setup.
 */
const PageViewTracker: FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const currentPath = location.pathname;
    trackPageView(currentPath);
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default PageViewTracker;
